var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            inline: "",
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "所属车库", prop: "upIdList" } },
            [
              _c("el-cascader", {
                staticClass: "form-item-width",
                attrs: {
                  clearable: "",
                  options: _vm.options,
                  props: _vm.propstree,
                  "change-on-select": "",
                  disabled: _vm.keyValue > 0
                },
                on: { change: _vm.getNode },
                model: {
                  value: _vm.childData.upIdList,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "upIdList", $$v)
                  },
                  expression: "childData.upIdList"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "停车场名称", prop: "garageName" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { clearable: "", type: "text" },
                model: {
                  value: _vm.childData.garageName,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "garageName", $$v)
                  },
                  expression: "childData.garageName"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "停车场编号" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: { clearable: "", type: "text" },
                model: {
                  value: _vm.childData.garageNo,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "garageNo", $$v)
                  },
                  expression: "childData.garageNo"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "车位(总量)" } },
            [
              _c("el-input-number", {
                staticClass: "form-item-width",
                attrs: { clearable: "", type: "text", min: 0, max: 99999 },
                model: {
                  value: _vm.childData.totalNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "totalNumber", $$v)
                  },
                  expression: "childData.totalNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "固定车位数" } },
            [
              _c("el-input-number", {
                staticClass: "form-item-width",
                attrs: { clearable: "", type: "text", min: 0, max: 99999 },
                model: {
                  value: _vm.childData.fixedNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "fixedNumber", $$v)
                  },
                  expression: "childData.fixedNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "临时车位数" } },
            [
              _c("el-input-number", {
                staticClass: "form-item-width",
                attrs: { clearable: "", type: "text", min: 0, max: 99999 },
                model: {
                  value: _vm.childData.temporaryNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "temporaryNumber", $$v)
                  },
                  expression: "childData.temporaryNumber"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "停车场类型", prop: "garageType" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "form-item-width",
                  staticStyle: { width: "330px" },
                  attrs: {
                    clearable: "",
                    filterable: "",
                    placeholder: "请选择停车场类型"
                  },
                  model: {
                    value: _vm.childData.garageType,
                    callback: function($$v) {
                      _vm.$set(_vm.childData, "garageType", $$v)
                    },
                    expression: "childData.garageType"
                  }
                },
                _vm._l(_vm.parkTypeOption, function(item) {
                  return _c("el-option", {
                    key: item.dicValue,
                    attrs: { label: item.dicName, value: item.dicValue }
                  })
                }),
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系人" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  clearable: "",
                  type: "text",
                  placeholder: "请输入联系人"
                },
                model: {
                  value: _vm.childData.garagePerson,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "garagePerson", $$v)
                  },
                  expression: "childData.garagePerson"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系电话" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  clearable: "",
                  type: "text",
                  placeholder: "请输入联系电话"
                },
                model: {
                  value: _vm.childData.garageTelephone,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "garageTelephone", $$v)
                  },
                  expression: "childData.garageTelephone"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "厂商" } },
            [
              _c("el-input", {
                staticClass: "form-item-width",
                attrs: {
                  clearable: "",
                  type: "text",
                  placeholder: "请输入厂商"
                },
                model: {
                  value: _vm.childData.garageBrand,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "garageBrand", $$v)
                  },
                  expression: "childData.garageBrand"
                }
              })
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "是否允许临停" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.childData.garageIsParking,
                        callback: function($$v) {
                          _vm.$set(_vm.childData, "garageIsParking", $$v)
                        },
                        expression: "childData.garageIsParking"
                      }
                    },
                    [
                      _c("el-radio", { attrs: { label: 0 } }, [_vm._v("否")]),
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("是")])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.precinctAddr") } },
            [
              _c("el-input", {
                staticStyle: { width: "680px" },
                attrs: {
                  clearable: "",
                  maxlength: "100",
                  type: "textarea",
                  placeholder: "请输入地址",
                  autosize: { minRows: 2, maxRows: 2 }
                },
                model: {
                  value: _vm.childData.garageAddr,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "garageAddr", $$v)
                  },
                  expression: "childData.garageAddr"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("table.explain") } },
            [
              _c("el-input", {
                staticStyle: { width: "680px" },
                attrs: {
                  clearable: "",
                  maxlength: "100",
                  type: "textarea",
                  placeholder: "请输入说明",
                  autosize: { minRows: 2, maxRows: 2 }
                },
                model: {
                  value: _vm.childData.garageRemark,
                  callback: function($$v) {
                    _vm.$set(_vm.childData, "garageRemark", $$v)
                  },
                  expression: "childData.garageRemark"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }